import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/partner/apps')({
  component: PartnerAppsLayout
});

function PartnerAppsLayout() {
  return <Outlet />;
}
